import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Equipment } from "../model/Equipment.model";
import { Observable } from "rxjs";
import { URL_API } from "./url.api";
import { Control } from "../model/Control.model";
import { Parameter } from "../model/Parameter.model";

@Injectable({
    providedIn: 'root'
})
export class EquipmentService {

    constructor(
        private http: HttpClient
    ){}

    findById(equipmentId: number): Observable<Equipment>{
        return this.http.get<Equipment>(`${URL_API}/equipment/${equipmentId}`);
    }

    save(equipment: Equipment){
        return this.http.post(`${URL_API}/equipment`, equipment);
    }

    update(equipment: Equipment){
        return this.http.put(`${URL_API}/equipment/${equipment.id}`, equipment);
    }

    delete(equipment: Equipment){
        return this.http.delete(`${URL_API}/equipment/${equipment.id}`);
    }

    findAll(): Observable<Array<Equipment>>{
        return this.http.get<Array<Equipment>>(`${URL_API}/equipment`); 
    }
    
    findControls(equipmentId): Observable<Array<Control>>{
        return this.http.get<Array<Control>>(`${URL_API}/equipment/${equipmentId}/controls`); 
    }

    findParameter(equipmentId): Observable<Array<Parameter>>{
        return this.http.get<Array<Parameter>>(`${URL_API}/equipment/${equipmentId}/parameters`); 
    }
}